import { Notification } from '@schibsted-svp/react-ui';
import { put, call, takeLatest } from '@redux-saga/core/effects';
import { adminBffClient } from 'services';
import { clipDownloadUrl, clipDownloadFailure, clipDownload } from './slice';

function* startStreamClipConversion(action: ReturnType<typeof clipDownload>) {
    const { provider, id, cutRange } = action.payload;

    try {
        const { url } = yield call(adminBffClient.prepareLiveArchiveConversionURL, provider, id, cutRange);

        if (!url) {
            const errorMessage = 'Live archive is no longer available.';

            yield put(
                clipDownloadFailure({
                    provider,
                    id,
                    cutRange,
                    error: errorMessage,
                })
            );

            return;
        }

        yield put(clipDownloadUrl({ id, provider, cutRange, url }));
    } catch (error) {
        yield put(clipDownloadFailure({ provider, id, cutRange, error: error.message }));

        Notification.notify.error('Cannot retireve live archive.');
    }
}

export default [takeLatest(clipDownload.type, startStreamClipConversion)];
